import {
  FETCH_GREAT_DEALS_NEW_ARRIVALS,
  FETCH_GREAT_DEALS_NEW_ARRIVALS_SUCCESS,
  FETCH_GREAT_DEALS_NEW_ARRIVALS_FAILURE,
  UPDATE_GREAT_DEALS,
  UPDATE_GREAT_DEALS_SUCCESS,
  UPDATE_GREAT_DEALS_FAILURE,
  UPDATE_NEW_ARRIVALS,
  UPDATE_NEW_ARRIVALS_SUCCESS,
  UPDATE_NEW_ARRIVALS_FAILURE,
  FETCH_BILLBOARD_IMAGES,
  FETCH_BILLBOARD_IMAGES_SUCCESS,
  FETCH_BILLBOARD_IMAGES_FAILURE,
  SAVE_BILLBOARD_IMAGES,
  SAVE_BILLBOARD_IMAGES_SUCCESS,
  SAVE_BILLBOARD_IMAGES_FAILURE,
  DELETE_BILLBOARD_IMAGE,
  DELETE_BILLBOARD_IMAGE_SUCCESS,
  DELETE_BILLBOARD_IMAGE_FAILURE,
} from '../actions/type';

const INITIAL_STATE = {
  productList: [],
  productListIsLoading: false,
  productListError: null,
  isGreatDealsUpdating: false,
  isGreatDealsUpdated: false,
  updateGreatDealsError: null,
  isNewArrivalsUpdating: false,
  isNewArrivalsUpdated: false,
  updateNewArrivalsError: null,
  billboardImagesList: [],
  billboardImagesIsLoading: false,
  billboardImagesError: null,
  savingBillboardImages: false,
  saveBillboardImagesSuccess: false,
  saveBillboardImagesError: null,
  deletingBillboardImage: false,
  deleteBillboardImageSuccess: false,
  deleteBillboardImageError: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_GREAT_DEALS_NEW_ARRIVALS:
      return {
        ...state,
        productList: [],
        productListIsLoading: true,
        productListError: null,
      };
    case FETCH_GREAT_DEALS_NEW_ARRIVALS_SUCCESS:
      return {
        ...state,
        productList: action.payload.data,
        productListIsLoading: false,
        productListError: null,
      };
    case FETCH_GREAT_DEALS_NEW_ARRIVALS_FAILURE: {
      const productListError = action.payload.data || { message: action.payload.message };
      alert(JSON.stringify(productListError));
      return {
        ...state,
        productList: [],
        productListIsLoading: false,
        productListError,
      };
    }
    case UPDATE_GREAT_DEALS:
      return {
        ...state,
        isGreatDealsUpdating: true,
        isGreatDealsUpdated: false,
        updateGreatDealsError: null,
      };
    case UPDATE_GREAT_DEALS_SUCCESS:
      return {
        ...state,
        isGreatDealsUpdating: false,
        isGreatDealsUpdated: true,
        updateGreatDealsError: null,
      };
    case UPDATE_GREAT_DEALS_FAILURE: {
      const updateGreatDealsError = action.payload.data || { message: action.payload.message };
      alert(JSON.stringify(updateGreatDealsError));
      return {
        ...state,
        isGreatDealsUpdating: false,
        isGreatDealsUpdated: false,
        updateGreatDealsError,
      };
    }
    case UPDATE_NEW_ARRIVALS:
      return {
        ...state,
        isNewArrivalsUpdating: true,
        isNewArrivalsUpdated: false,
        updateNewArrivalsError: null,
      };
    case UPDATE_NEW_ARRIVALS_SUCCESS:
      return {
        ...state,
        isNewArrivalsUpdating: false,
        isNewArrivalsUpdated: true,
        updateNewArrivalsError: null,
      };
    case UPDATE_NEW_ARRIVALS_FAILURE: {
      const updateNewArrivalsError = action.payload.data || { message: action.payload.message };
      alert(JSON.stringify(updateNewArrivalsError));
      return {
        ...state,
        isNewArrivalsUpdating: false,
        isNewArrivalsUpdated: false,
        updateNewArrivalsError,
      };
    }
    case FETCH_BILLBOARD_IMAGES:
      return {
        ...state,
        billboardImagesList: [],
        billboardImagesIsLoading: true,
        billboardImagesError: null,
      };
    case FETCH_BILLBOARD_IMAGES_SUCCESS:
      return {
        ...state,
        billboardImagesList: action.payload.data,
        billboardImagesIsLoading: false,
        billboardImagesError: null,
      };
    case FETCH_BILLBOARD_IMAGES_FAILURE: {
      const billboardImagesError = action.payload.data || { message: action.payload.message };
      alert(JSON.stringify(billboardImagesError));
      return {
        ...state,
        billboardImagesList: [],
        billboardImagesIsLoading: false,
        billboardImagesError: null,
      };
    }
    case SAVE_BILLBOARD_IMAGES:
      return {
        savingBillboardImages: true,
        saveBillboardImagesSuccess: false,
        saveBillboardImagesError: null,
      };
    case SAVE_BILLBOARD_IMAGES_SUCCESS:
      return {
        savingBillboardImages: false,
        saveBillboardImagesSuccess: true,
        saveBillboardImagesError: null,
      };
    case SAVE_BILLBOARD_IMAGES_FAILURE: {
      const saveBillboardImagesError = action.payload.data || { message: action.payload.message };
      alert(JSON.stringify(saveBillboardImagesError));
      return {
        savingBillboardImages: false,
        saveBillboardImagesSuccess: false,
        saveBillboardImagesError,
      };
    }
    case DELETE_BILLBOARD_IMAGE:
      return {
        deletingBillboardImage: true,
        deleteBillboardImageSuccess: false,
        deleteBillboardImageError: null,
      };
    case DELETE_BILLBOARD_IMAGE_SUCCESS:
      return {
        deletingBillboardImage: false,
        deleteBillboardImageSuccess: true,
        deleteBillboardImageError: null,
      };
    case DELETE_BILLBOARD_IMAGE_FAILURE: {
      const deleteBillboardImageError = action.payload.data || { message: action.payload.message };
      alert(JSON.stringify(deleteBillboardImageError));
      return {
        deletingBillboardImage: false,
        deleteBillboardImageSuccess: false,
        deleteBillboardImageError,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/mobileManagement_reducer.js